/* eslint-disable import-x/no-duplicates */
// @ts-nocheck
import { useEffect, useState, FC, PropsWithChildren } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getAuthRefreshToken } from '@modules/auth/selectors';
import { SDK } from '@utils/api';
import WS from '@utils/api/ws';
import { store } from '@store/index';
import { connectWS } from '@modules/websocket/actions';

const SdkLoader: FC<PropsWithChildren<{}>> = ({ children }) => {
  const dispatch = useDispatch();
  const token = useSelector(getAuthRefreshToken);

  useEffect(() => {
    (async () => {
      try {
        if (token) {
          WS.setToken(token);
          WS.init().then(() => dispatch(connectWS())).catch(() => {});
        }
        SDK.init(store).then(() => SDK.setToken(token)).catch(() => {});
        SDK.setToken(token);
      } catch {
        // non-blocking
      }
    })();
  }, [token, dispatch]);

  return children;
};

export default SdkLoader;
